import {makeTrackEvent} from './makeTrackEvent';

/**
 * Event name for workspace feedback submissions. Follows the Object-Action,
 * Title Case convention documented in services/analytics/README.md.
 */
export const FEEDBACK_EVENT_NAME = 'User Feedback Submitted';

export type FeedbackSubmittedData = {
  area: string;
  comment: string;
  page: string;
  url: string;
  entityName?: string;
  projectName?: string;
  userId?: string;
  userEmail?: string;
};

type FeedbackSubmittedDescriptions = {
  area: {
    description: 'Which product area the feedback is about';
    exampleValues: ['runs', 'reports', 'weave'];
  };
  comment: {
    description: 'Free-form feedback text entered by the user';
  };
  page: {
    description: 'Pathname of the page the feedback drawer was opened from';
    exampleValues: ['/entity/project'];
  };
  url: {
    description: 'Full URL the feedback drawer was opened from';
  };
  entityName: {
    description: 'Entity (team) the user was viewing, if any';
  };
  projectName: {
    description: 'Project the user was viewing, if any';
  };
  userId: {
    description: 'ID of the user who submitted the feedback';
  };
  userEmail: {
    description: 'Email of the user who submitted the feedback';
  };
};

type FeedbackSubmittedMeta = {
  _description: 'Fired when a user submits the workspace feedback drawer';
  _location: 'Workspace feedback drawer, opened from the project sidebar Feedback button';
  _motivation: 'Collect qualitative product feedback for Product and Engineering';
};

export const trackFeedbackSubmitted = makeTrackEvent<
  FeedbackSubmittedData,
  FeedbackSubmittedDescriptions & FeedbackSubmittedMeta
>(FEEDBACK_EVENT_NAME);
